<topo-modal [isActive]="showDialog" [backgroundCanClose]="false" [width]="812" (close)="onClose()" [isCard]="true" id="wizard">
  <div class="modal-header">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <div class="mx-4 my-4" fxLayout="row" fxLayoutAlign="space-between" #header>
        @if (showDialog) {
          <h5>{{ title }}</h5>
        }
      </div>
      <div class="dialog-close mr-4" (click)="onClose()"><i class="icon icon-close-X"></i></div>
    </div>
  </div>
  <div class="modal-body wizard-page-container">
    @if (!!selectDatasets && !singleDataset && (!_dataset || !_document)) {
      <div class="wizard-page">
        <div class="select is-secondary is-medium">
          <select [(ngModel)]="selectedDatasetUId" (change)="datasetChanged($event)">
            @for (dataset of selectDatasets; track dataset.uId) {
              <option [ngValue]="dataset.uId">
                {{ dataset.name }}
              </option>
            }
          </select>
        </div>
      </div>
    }

    @for (wizardPage of wizardPages; track wizardPage.view.uId) {
      <div class="wizard-page" [hidden]="!showView(wizardPage)">
        <div>
          <div fxlayout="row" fxlayoutalign="start center">
            <div class="data-section" [ngClass]="{ full: !showViewDesc(wizardPage) }">
              <div>
                @if (isOneCompletedWorkflowSteps) {
                  <div class="font-weight-bold row mt-2  mb-5 summary upper">
                    <h6>{{ 'INCIDENTS.INCIDENT_FROM_ALERT_COMPLETED_WORKFLOW_STEP_MESSAGE_SINGLE_STEP' | translate: { step: uniqueWorkflowStep.statusName } }}</h6></div>
                  }
                  @if (isMultipleCompletedWorkflowSteps) {
                    <div class="font-weight-bold row mt-2  mb-5 summary upper">
                      <h6> {{ 'INCIDENTS.INCIDENT_FROM_ALERT_COMPLETED_WORKFLOW_STEP_MESSAGE_MULT_STEP' | translate }} *</h6>
                      <div class="row mt-2  mb-5  select is-secondary is-medium">
                        <select [(ngModel)]="selectedCompletedWorkflowStepUId" required (change)="completedWorkflowStepChanged($event)">
                          <option [ngValue]="null" disabled selected hidden>{{ 'INCIDENTS.DROPDOWN_PLACE_HOLDER' | translate }}</option>
                          @for (workflowstep of multipleWorkflowSteps; track workflowstep.uId) {
                            <option [ngValue]="workflowstep.uId">
                              {{ workflowstep.statusName }}
                            </option>
                          }
                        </select>
                      </div>
                    </div>
                  }
                </div>
                <div topoDynamicForm
                  [formView]="wizardPage?.view"
                  [schema]="schema"
                  [document]="_document"
                  [controlCollection]="wizardPage?.controls"
                  [isEdit]="true"
                  [configureControl]="configureControl"
                  [dataset]="_dataset"
                  [layerUId]="guidEmpty"
                ></div>
              </div>
              @if (showViewDesc(wizardPage)) {
                <div
                  class="instructions-section"
                  [innerHTML]="wizardPage?.view?.configuration['pageDesc']"
                ></div>
              }
            </div>
          </div>
        </div>
      }
    </div>
    <div class="modal-footer">
      <section class="field buttons wizard-buttons" fxLayout="row">
        <span fxLayoutAlign="start">
          <button [style.display]="showBack ? 'block' : 'none'" class="button is-secondary mr-2" (click)="backClick()">
            <span class="icon icon-arrow2_left left-icon"></span>
            {{ 'INCIDENTS.BUTTONS.BACK' | translate }}
          </button>
        </span>
        <span fxLayoutAlign="end">
          <button class="button is-secondary mr-2" (click)="onClose()">{{ 'MANAGEMENT.BUTTONS.CANCEL' | translate }}</button>
          <button [disabled]="!canNext" [style.display]="showNext ? 'block' : 'none'" class="button is-primary" (click)="nextClick()">
            {{ 'MANAGEMENT.BUTTONS.NEXT' | translate }}
            <span class="icon icon-arrow2_right right-icon"></span>
          </button>
          <button [disabled]="!canCreate || (isMultipleCompletedWorkflowSteps && (selectedCompletedWorkflowStepUId == null || selectedCompletedWorkflowStepUId == ''))" [style.display]="showCreate ? 'block' : 'none'" class="button is-primary" (click)="saveClick()">
            {{ 'MANAGEMENT.BUTTONS.CREATE' | translate }}
          </button>
        </span>
      </section>
    </div>
  </topo-modal>
